import { RequestContext } from 'DVWebNodeUtils'

const webDeviceInfo = {
  deviceTypeId: 'A13Q6A55DBZB7M'
}

const spaDeviceInfo = {
  deviceTypeId: 'A3OEMT9S4WNMK',
}

export const getDeviceInfo = () =>
  global.__NATIVEAPP__ ? spaDeviceInfo : webDeviceInfo

export const isRobot = (requestContext: RequestContext) =>
  requestContext.sessionID === '000-0000000-0000000'
